export const tableTitle = ['Порядковий номер','№ Договору', "Назва договору", "Лікарня", 'Дата початку договору', 'Дата завершення договору', 'Статус', '']

export const filterDate = [
    {name: 'id', placeholder: 'Пошук за порядковим номером'},
    {name: 'number', placeholder: 'Пошук за №'},
    {name: 'name', placeholder: "Пошук за назвою"},
    {name: 'hospitalName', placeholder: 'Пошук за лікарнею'},
    {name: 'startDateFrom', type: 'date', placeholder: 'Пошук за датою початку договору'},
    {name: 'endDateTo', type: 'date', placeholder: 'Пошук за датою завершення договору'},
    {name: 'status', type: 'select', options: [
            {name:'Усі', value: ''}, 
            {name:'Дійсний', value: 'active'},
            {name:'Закінчився термін дії', value: 'expired'},
            {name:'Скасований', value: 'cancelled'},
            {name:'Завершений', value: 'finished'},], placeholder: 'Пошук за статусом'},
]

export const searchOptions = [
    { "value": "number", "name": "за №", "type": "number" },
    { "value": "name", "name": "за назвою", "type": "text" },
    { "value": "hospitalId", "name": "за лікарнею", "type": "text" },
    { "value": "startDate", "name": "за датою початку договору", "type": "date" },
    { "value": "endDate", "name": "за датою завершення договору", "type": "date" },
    { "value": "status", "name": "за статусом", "type": "text" },
];
